import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MatDialog } from '@angular/material/dialog';
import { of } from 'rxjs';
import { map, catchError, switchMap, filter, tap } from 'rxjs/operators';
import { ManagementApiService } from '../management-api.service';
import { AddConsumerTypeDialogComponent } from '@emm/shared/dialogs/add-consumer-type-dialog/add-consumer-type-dialog.component';
import {ConsumerTypesActions} from '@emm/management/store/consumer-types/consumer-types.actions';
import {NotificationService} from '@emm/shared/services/notification.service';

@Injectable({
    providedIn: 'root'
})
export class ConsumerTypesEffects {

    loadAll$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ConsumerTypesActions.loadAll),
            switchMap(() =>
                this.api.getConsumerTypes().pipe(
                    map((consumerTypes) => ConsumerTypesActions.loadAllSuccess({ consumerTypes })),
                    catchError(({ error }) => of(ConsumerTypesActions.loadAllFailure({ error })))
                )
            )
        )
    );

    openAddDialog$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ConsumerTypesActions.openAddDialog),
            switchMap(() => {
                const dialogRef = this.dialog.open(AddConsumerTypeDialogComponent, {
                    width: '600px',
                    data: { showDelete: false }
                });

                return dialogRef.afterClosed().pipe(
                    filter((result) => result && result === 'submit'),
                    tap(() => {
                        this.notificationService.success('Added Successfully');
                    }),
                    map(() =>ConsumerTypesActions.loadAll())
                );
            })
        )
    );

    constructor(
        private actions$: Actions,
        private api: ManagementApiService,
        public dialog: MatDialog,
        private notificationService: NotificationService
    ) {}

}
